<template>
    <div class="page page-center">
        <div class="container-tight py-4">
            <div class="empty">
                <div class="empty-img">
                    <icon icon="mood-sad" height="128" />
                </div>
                <p class="empty-title">404</p>
                <p class="empty-subtitle text-muted">
                    Not Found
                </p>
                <div class="empty-action">
                    <router-link :to="{ 'name': 'home' }" class="btn btn-primary">
                        <icon icon="home" height="24" />
                        Home
                    </router-link>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
export default {
};
</script>
